import { getTelegramWebApp, isTelegramWebAppActive } from '@/utils/telegramWebAppClient'
import logger from '@/utils/logger'

function fallbackCopyText(text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.setAttribute('readonly', '')
  textArea.style.position = 'fixed'
  textArea.style.left = '-9999px'
  document.body.appendChild(textArea)
  textArea.select()
  try {
    return document.execCommand('copy')
  } catch (error) {
    logger.warn('Fallback clipboard copy failed:', error)
    return false
  } finally {
    document.body.removeChild(textArea)
  }
}

/**
 * Copy text with Telegram clipboard API when available.
 */
export async function writeAppClipboard(text) {
  const value = String(text ?? '')
  if (!value) return false

  const tg = getTelegramWebApp()
  if (isTelegramWebAppActive() && tg?.writeTextToClipboard) {
    return new Promise((resolve) => {
      try {
        tg.writeTextToClipboard(value, (success) => resolve(!!success))
      } catch (error) {
        logger.warn('Telegram clipboard write failed:', error)
        resolve(false)
      }
    })
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value)
      return true
    }
  } catch (error) {
    logger.warn('Navigator clipboard write failed:', error)
  }

  return fallbackCopyText(value)
}
